import { makeAutoObservable, runInAction } from 'mobx';
import { BootleByRoomDataInterface } from 'screens/CalculationsScreen/components/BottleByRoomCalculationTable/bottlebyroom.types';
import { bottleByRoomCalculationsServices } from 'services/CalculationServices/bottlebyroomCalculationsServices';

export class BottleByRoomCalculationStore {
  bottleByRoomCalculations: BootleByRoomDataInterface[] = [];
  isLoading: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  fetchBottleByRoomCalculations = async (date: string) => {
    try {
      this.isLoading = true;

      const data = await bottleByRoomCalculationsServices.getBottleByRoom(date);

      if (data.success) {
        runInAction(() => {
          this.bottleByRoomCalculations = data.data;
        });
      }
    } catch (error) {
      runInAction(() => {
        this.bottleByRoomCalculations = [];
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };
}
